<template>
    <BackButton @click="beb"/>
    <div class="languages">
        <div class="language" id="light" @click="changeTheme">
            <div class="firstLang">
                <p>{{ $t("lightThemeFull") }}</p>
            </div>
            <img class="galka" src="../assets/icons/galka.svg" v-if="theme == 'light'"/>
        </div>
        <hr class="hrSetting">
        <div class="language" id="dark" @click="changeTheme">
            <div class="firstLang">
                <p>{{ $t("darkThemeFull") }}</p>
            </div>
            <img class="galka" src="../assets/icons/galka.svg" v-if="theme == 'dark'"/>
        </div>
    </div>
</template>

<script>
import { BackButton } from 'vue-tg'
export default {
    name: "SelectTheme",
    data() {
        return {
            theme: this.$store.getters.getTheme
        }
    },
    methods: {
        beb() {
            this.$emit('changeMode', "SelectTheme")
        },
        changeTheme(event) {
            const selected = event.target.closest('div.language')?.id
            if (!selected) return
            this.theme = selected
            this.$store.commit('setTheme', selected)
            document.documentElement.setAttribute('data-theme', selected);
        }
    },
    components: {BackButton}
};
</script>

<style scoped>
.languages {
    background-color: var(--second-color);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    position: relative;
}
.language {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 17px;
    padding: 4%;
    transition: all 0.3s;
    cursor: pointer;
}
.language:active {
  scale:0.97;
}
.firstLang {
    display: flex;
    gap:10px;
    align-items: center;
}
.galka {
    width:5vw;
}
.hrSetting {
  width: 95%;
  text-align: right;
  border: 0.5px solid var(--hr-color);
  margin: 0 auto;
}
</style>
